import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import {titleCase} from '../../../../utils/views/pages/Dynamics'

const InstitutionInformation = (props) => {
    const institution = props.institution
    const formDisabled = props.formDisabled
    const setInstitution = props.setInstitution
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations

    let validateField = (e) => {
        //console.log(!e.target.value.trim() && e.target.required)
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {                
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {
        
        institution[e.target.name] = e.target.value
        setInstitution(institution)

    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Institution information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-name"
                            >
                                Name
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={institution?.name}
                                id="input-name"
                                name="name"
                                placeholder="Institution Name"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-email"
                            >
                                Email address
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-email"
                                defaultValue={institution?.email}
                                type="email"
                                name="email"
                                placeholder="Institution Email"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-phone"
                            >
                                Phone
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-phone"
                                defaultValue={institution?.phone}
                                type="phone"
                                disabled={formDisabled}
                                placeholder="Number"
                                name="phone"
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default InstitutionInformation;